// src/utils/variantChangeHelpers.ts
import { type ProductVariant, type VariantChanges, type ProductImage } from '../types';

export const getVariantChange = (
  variantId: number,
  fieldName: string,
  isReviewMode: boolean,
  changeSummary?: ChangeSummary
): { value: any; previous: any; hasChanged: boolean } => {
  if (!isReviewMode || !changeSummary?.variants) {
    return { value: undefined, previous: undefined, hasChanged: false };
  }

  const { variants } = changeSummary;
  
  // Check if variant was added
  const addedVariant = variants.added.find(v => v.id === variantId);
  if (addedVariant) {
    return {
      value: addedVariant[fieldName],
      previous: undefined,
      hasChanged: true
    };
  }

  // Check if variant was changed
  const changedVariant = variants.changed.find(v => v.id === variantId);
  if (changedVariant && changedVariant.changed_fields[fieldName]) {
    const change = changedVariant.changed_fields[fieldName];
    return {
      value: change.new,
      previous: change.old,
      hasChanged: true
    };
  }

  // Find current value from form data or new list
  const variantData = variants.new.find(v => v.id === variantId);
  return {
    value: variantData?.[fieldName],
    previous: undefined,
    hasChanged: false
  };
};

export const getVariantStatus = (
    variant: ProductVariant,
    isReviewMode: boolean
): 'added' | 'removed' | 'changed' | 'existing' => {
    if (!isReviewMode) return 'existing';
    return variant._action || 'existing';
};


export const getVariantChangeCounts = (
  isReviewMode: boolean,
  changeSummary?: ChangeSummary
): { added: number; removed: number; changed: number } => {
  if (!isReviewMode || !changeSummary?.variants) {
    return { added: 0, removed: 0, changed: 0 };
  }

  return {
    added: changeSummary.variants.added.length,
    removed: changeSummary.variants.removed.length,
    changed: changeSummary.variants.changed.length
  };
};